import { useQuery } from '@tanstack/react-query';

import { getPresignedGetUrl } from '@/services/files.service';

export function usePresignedImageUrl(
  key?: string | null,
  options?: { refetchOnMount?: boolean | 'always' },
) {
  const enabled = !!key;

  const query = useQuery({
    queryKey: ['presigned-image-url', key],
    queryFn: () => {
      if (!key) {
        throw new Error('Missing key for presigned image URL');
      }
      return getPresignedGetUrl(key);
    },
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes — 5-min buffer before S3 URL expiry
    refetchOnMount: options?.refetchOnMount ?? true,
  });

  return query;
}

